export function SkipLink() {
  return (
    <a
      href="#hauptinhalt"
      className="fixed top-3 left-3 z-50 -translate-y-[220%] rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm outline-none focus:translate-y-0 focus:ring-[3px] focus-visible:translate-y-0 focus-visible:ring-[3px] focus-visible:ring-ring"
    >
      Zum Inhalt
    </a>
  );
}
